module.exports = __webpack_public_path__ + "assets/img/provider-poster-01.44fb443b.png";